"use client";
import { jsx as l, jsxs as h } from "react/jsx-runtime";
import m, { createContext as y, useContext as c } from "react";
import { classNames as s } from "../../utilities/index.js";
import I from "../Image/index.js";
import b from "../Icon/index.js";
const i = y(null), o = ({ className: e, variant: t, children: r, ...a }) => {
  const n = s({
    "sash-TextCard flex flex-col bg-white h-full border border-gray-15 transition-shadow relative [&:has(a)]:hover:shadow-lg": !0,
    "sash-TextCard--white p-6": t === "inline-icon-white",
    [e]: e
  });
  return /* @__PURE__ */ l(i.Provider, { value: t, children: /* @__PURE__ */ l(
    "div",
    {
      className: n,
      ...a,
      children: r
    }
  ) });
}, C = ({ className: e, content: t, children: r, ...a }) => {
  var u, x;
  const n = c(i), d = s({
    "sash-CardHeading font-semibold flex items-center w-full": !0,
    "text-white bg-black": !n,
    "sash-CardHeading--noChild text-lg !leading-normal p-2 justify-center border-b-4 border-b-primary md:text-xl": !n && ((u = m.Children.toArray(r)) == null ? void 0 : u.length) === 0,
    "text-sm leading-none py-3 px-5 justify-center": !n && ((x = m.Children.toArray(r)) == null ? void 0 : x.length) > 0,
    "justify-center leading-tight text-xl": n === "inline-icon-white",
    [e]: e
  });
  return /* @__PURE__ */ h(
    "div",
    {
      className: d,
      ...a,
      children: [
        r,
        t && /* @__PURE__ */ l("div", { dangerouslySetInnerHTML: { __html: t } })
      ]
    }
  );
}, f = ({ className: e, name: t, ...r }) => {
  const a = c(i), n = s({
    "sash-CardIcon mr-3": !0,
    "text-primary": !a,
    "bg-primary rounded-full w-9 h-9 flex justify-center items-center flex-[0_0_36px]": a === "inline-icon-white",
    [e]: e
  });
  return t ? /* @__PURE__ */ l(
    b,
    {
      className: n,
      name: t,
      ...r
    }
  ) : null;
}, p = ({ className: e, src: t, ...r }) => {
  const a = s({
    "sash-CardIcon mr-3 w-6 h-6 flex-[0_0_24px]": !0,
    [e]: e
  });
  return t ? /* @__PURE__ */ l(
    I,
    {
      src: t,
      className: a,
      objectFit: "contain",
      alt: "",
      ...r
    }
  ) : null;
}, g = ({ className: e, content: t, children: r, ...a }) => {
  const n = c(i), d = s({
    "sash-CardContent flex flex-col h-full [&>ul]:mt-auto [&>ul]:pt-4": !0,
    "p-4": !n,
    "pt-6 text-center": n === "inline-icon-white",
    [e]: e
  });
  return /* @__PURE__ */ h(
    "div",
    {
      className: d,
      ...a,
      children: [
        t && /* @__PURE__ */ l(
          "div",
          {
            className: "[&>ul]:m-0 [&>ul]:space-y-1 [&>ul]:py-0 [&>ul]:pl-5 [&>ul]:text-left",
            dangerouslySetInnerHTML: { __html: t }
          }
        ),
        r
      ]
    }
  );
};
o.Heading = C;
o.Icon = f;
o.Image = p;
o.Content = g;
C.displayName = "TextCard.Heading";
f.displayName = "TextCard.Icon";
p.displayName = "TextCard.Image";
g.displayName = "TextCard.Content";
const j = o;
export {
  j as default
};
